// var GRAnalytics = require('./modules/GRAnalytics');
// var grtracking = new GRAnalytics({
//     trackingPixels: {'facebook': 6019307275151}
// });
//
// grtracking.fireTrackingPixels('facebook', {revenue: 5, currency: "USD"});
// grtracking.fireTrackingPixels('facebook', {revenue: 10, currency: "USD"});

var GRaygun = require('./modules/GRaygun');
var graygunner = new GRaygun();

// var ENSender = require('./modules/ENSender');
// var sender = new ENSender({form: $('.form')});
// sender.send({data: $('.form').serializeArray()});
/*try {
    throw new Error("Test");
}
catch(e) {
    graygunner.sendError(e);
}*/

/*var GRGivingSupport = require('./modules/GRGivingSupport');

var grgiving = new GRGivingSupport({
    components: {
        recurrence: {
            selector: '[name="Recurring Payment"]',
            defaultVal: ''
        }
    },
    recurrenceOptions: [
        {label: 'One-time', 'value': ''},
        {label: 'Monthly', 'value': 'Y'}
    ]
});*/

var accessLanguage = {};

accessLanguage.go = function() {
  var $html = $("html");

    $("button").click(function(event){
      event.preventDefault();
      $html.toggleClass("accessible-text");
    });
};

$(document).ready(function(){
  accessLanguage.go();

  function highlightSelectedFilter() {
    var href = window.location.href,
        url = href.split('&'),
        type = url[url.length - 1],
        artistB = document.getElementsByClassName('artistB'),
        descAlphaB = document.getElementsByClassName('desc-alphabeticalB'),
        alphaB = document.getElementsByClassName('artistB'),
        watchB = document.getElementsByClassName('watchB'),
        recentB = document.getElementsByClassName('recentB'),
        popularB = document.getElementsByClassName('popularB'),
        suggestedB = document.getElementsByClassName('suggestedB'),
        upcomingB = document.getElementsByClassName('upcomingB');
    console.log(href, url, type);
    function highlight(item) {
      for (var i = 0; i < item.length; i++) { item[i].className += " activeB"; }
    }

    switch (type) {
      case 'alphabetical': highlight(artistB); break;
      case 'descalphabetical': highlight(descAlphaB); break;
      case  href: highlight(recentB); break;
      case 'popular': highlight(popularB); break;
      case 'suggested': highlight(suggestedB); break;
      case 'upcoming': highlight(upcomingB); break;
      case 'watch': highlight(watchB); break;
    }
  } highlightSelectedFilter();
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/main.js
 ** module id = 0
 ** module chunks = 1
 **/